module.exports = __webpack_public_path__ + "media/images/iconSocialFacebook__inactive--dark-cdad131aedd8a721b2595996ce51a949.png";